export const googleMapKey = 'AIzaSyAq8MGAPNO-7J5z7MGu1AKkQ4MFz4hpcPU';

export const reCaptchaApiKey = '6Ldb1JgUAAAAANufBLgANmSgJJVtYvZnJIMBLMqR';